module.exports = __webpack_public_path__ + "img/Stortingsmelding-nr.-31_Forste-bilde..c0f70ba9.jpg";